'use client'
import { ComponentPropsWithoutRef } from 'react'
import { ComparisonTable } from './ComparisonTable'
import { type ComparisonTableProps } from './ComparisonTable.types'

type Props = ComparisonTableProps & {
  selectedColumn?: string
  className?: string
  headerSize?: ComponentPropsWithoutRef<typeof ComparisonTable.Header>['size']
  isFirstHeaderFeatured?: boolean
}

export const DesktopComparisonTable = ({
  className,
  head,
  body,
  selectedColumn,
  caption,
  headerSize,
  isFirstHeaderFeatured,
}: Props) => {
  const selectedColumnIndex = head.findIndex((headerValue) => headerValue === selectedColumn)

  return (
    <ComparisonTable.Root className={className} caption={caption}>
      <ComparisonTable.Head>
        <ComparisonTable.Row>
          {head.map((headerValue, index) => {
            return (
              <ComparisonTable.Header
                key={`${headerValue || 'empty-header'}-${index}`}
                active={headerValue === selectedColumn}
                featured={isFirstHeaderFeatured && index === 0}
                size={headerSize}
                alignment={getAlignment(head.length, index)}
              >
                {headerValue}
              </ComparisonTable.Header>
            )
          })}
        </ComparisonTable.Row>
      </ComparisonTable.Head>

      <ComparisonTable.Body>
        {body.map((row) => {
          const [rowTitle, ...values] = row

          return (
            <ComparisonTable.Row key={rowTitle.title}>
              <ComparisonTable.TitleDataCell
                style={{ width: '60%' }}
                title={rowTitle.title}
                description={rowTitle.description}
                perilColor={rowTitle.perilsColor}
                coverageList={rowTitle.coverageList}
              />
              {values.map((value, index) => (
                <ComparisonTable.DataCell
                  key={index}
                  style={{ width: `calc(40% / ${values.length})` }}
                  active={index + 1 === selectedColumnIndex}
                  alignment={getAlignment(head.length, index + 1)}
                >
                  {value}
                </ComparisonTable.DataCell>
              ))}
            </ComparisonTable.Row>
          )
        })}
      </ComparisonTable.Body>
    </ComparisonTable.Root>
  )
}

function getAlignment(numberOfColumns: number, index: number) {
  if (numberOfColumns > 2) {
    return index === 0 ? 'left' : 'center'
  }

  return index === 0 ? 'left' : 'right'
}
